import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetShippersDeliveryOperationsResponse } from '~/types/delivery-agency.types';

const useGetShippersDeliveryOperations = () => {
  const { runAsync } = useAsyncHandler();

  const getShippersDeliveryOperations = useAPI<unknown, TypeGetShippersDeliveryOperationsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPERS_DELIVERY_OPERATIONS,
    method: 'get',
  });

  const requestDeliveryOperations = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypeGetShippersDeliveryOperationsResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) => {
    runAsync(() => getShippersDeliveryOperations({}), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestDeliveryOperations };
};

export default useGetShippersDeliveryOperations;
